class VideoOverlayHandler extends HTMLElement {
  constructor() { 
    super();
    let videoContainer = this.querySelector(`.js-video-container`),
        enabledVideo   = this.querySelector(`.js-video-container`).getAttribute('data-controls') === 'true' ? true : false,
        video 				 = videoContainer.querySelector('video');
  
    if(enabledVideo) {
      video?.addEventListener('touchstart', e => {
        e.preventDefault();
        video.controls = true;  
      })
  
      video?.addEventListener('click', e => {
        e.preventDefault();
        video.controls = true;
      })
  
      video?.addEventListener('mouseover', e => {
        e.preventDefault();
        video.controls = true;
      })
    }
  }
} 

customElements.define('overlay-handler', VideoOverlayHandler)